import { render, staticRenderFns } from "./ContractPercentageFluctuationList.vue?vue&type=template&id=48885238"
import script from "./ContractPercentageFluctuationList.vue?vue&type=script&lang=js"
export * from "./ContractPercentageFluctuationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports